var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OperationLog',{ref:"operationLog",attrs:{"searchFields":_vm.searchFields,"tableData":_vm.tableData},scopedSlots:_vm._u([{key:"optType",fn:function(text){return [_vm._v(" "+_vm._s(_vm.typeFormate(text))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }